export default "__VITE_ASSET__1f24c273__"